import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import "../layout/Home/Home.css";
import docimage from "../assets/images/docimage.png";
import userimg from "../assets/images/userimg.png";
import Header from "../components/Header";
import Footer from "../components/Footer";

import LocalHospitalOutlinedIcon from "@mui/icons-material/LocalHospitalOutlined";
import SchoolOutlinedIcon from "@mui/icons-material/SchoolOutlined";
import ClosedCaptionOutlinedIcon from "@mui/icons-material/ClosedCaptionOutlined";
import PlaceOutlinedIcon from "@mui/icons-material/PlaceOutlined";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import VerifiedIcon from "@mui/icons-material/Verified";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";
import StarOutlinedIcon from "@mui/icons-material/StarOutlined";

import LocalHospitalIcon from "@mui/icons-material/LocalHospital";
import VideocamIcon from "@mui/icons-material/Videocam";
import HomeIcon from "@mui/icons-material/Home";
import "../caregiver/nursingcare/NursingCare.css";
import WhyTrust from "../layout/WhyTrust";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import WbTwilightOutlinedIcon from '@mui/icons-material/WbTwilightOutlined';
import CallIcon from '@mui/icons-material/Call';
import { fetchAPI } from "../utils/api";

import { ShimmerThumbnail, ShimmerTitle, ShimmerText, ShimmerButton } from "react-shimmer-effects";

const tabs = ["Experience & Education", "Patient Reviews", "Availability"];

const reviews = [
  {
    id: 1,
    name: "Priya Patel",
    image: userimg,
    rating: 5,
    date: "2 Days ago",
    review:
      "Dr. Sonam Agarwal provided excellent care during my father's ICU recovery. Her calm nature and timely treatment gave our family great confidence.",
  },
  {
    id: 2,
    name: "Priya Patel",
    image: userimg,
    rating: 5,
    date: "2 Days ago",
    review:
      "Dr. Sonam Agarwal provided excellent care during my father's ICU recovery. Her calm nature and timely treatment gave our family great confidence.",
  },
];

function DoctorDetail() {
  const { slug } = useParams();
  const [doctor, setDoctor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState("Experience & Education");
  const [showMore, setShowMore] = useState(false);

  useEffect(() => {
    const loadDoctorDetail = async () => {
      try {
        setLoading(true);
        // If slug is a number, use doctor_id; otherwise use doctor_slug
        const isNumeric = slug && /^\d+$/.test(slug);
        const payload = isNumeric ? { doctor_id: slug } : (slug ? { doctor_slug: slug } : { doctor_id: 1 });
        const data = await fetchAPI("DoctorController/doctor_detail", {
          method: "POST",
          body: JSON.stringify(payload)
        });

        if (data && data.status === 200) {
          setDoctor(data.result || null);
        } else {
          setError(data ? data.msg : "Doctor not found.");
        }
      } catch (err) {
        console.error("Error loading doctor detail:", err);
        setError("Failed to load doctor details. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    loadDoctorDetail();
  }, [slug]);

  if (loading) {
    return (
      <>
        <Header />
        <div className="container-fluid my-5 py-3">
          <div className="row g-4">
            <div className="col-xl-8 col-lg-12">
              <div className="p-4 bg-white border rounded shadow-sm d-flex gap-4 align-items-center mb-4">
                <ShimmerThumbnail height={140} width={140} rounded />
                <div className="flex-grow-1">
                  <ShimmerTitle line={2} gap={10} variant="subheading" />
                  <ShimmerText line={2} gap={10} />
                </div>
              </div>
              <div className="p-4 bg-white border rounded shadow-sm mb-4">
                <ShimmerTitle line={1} gap={10} variant="subheading" />
                <ShimmerText line={4} gap={10} />
              </div>
            </div>
            <div className="col-xl-4 col-lg-12">
              <div className="p-4 bg-white border rounded shadow-sm">
                <ShimmerTitle line={2} gap={10} variant="subheading" />
                <div className="my-3">
                  <ShimmerButton size="lg" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error || !doctor) {
    return (
      <>
        <Header />
        <div className="container my-5 py-5 text-center">
          <div className="alert alert-danger">{error || "Doctor details not found."}</div>
          <Link to="/doctor-consultation-services" className="btn btn-primary" style={{ backgroundColor: '#13baac', borderColor: '#13baac' }}>
            Back to Doctors List
          </Link>
        </div>
        <Footer />
      </>
    );
  }

  const specialityText = doctor.specializations?.map(s => s.specialization_name).join(', ') || "Medical Consultant";
  const languagesText = doctor.languages?.map(l => l.language_name).join(', ') || "English, Hindi";

  const hasVideo = doctor.consultation_types?.some(c => c.consultation_type_name.toLowerCase().includes('video'));
  const hasHome = doctor.consultation_types?.some(c => c.consultation_type_name.toLowerCase().includes('home'));
  const hasClinic = doctor.consultation_types?.some(c => c.consultation_type_name.toLowerCase().includes('clinic') || c.consultation_type_name.toLowerCase().includes('hospital') || c.consultation_type_name.toLowerCase().includes('in-clinic'));

  const videoType = doctor.consultation_types?.find(c => c.consultation_type_name.toLowerCase().includes('video'));
  const homeType = doctor.consultation_types?.find(c => c.consultation_type_name.toLowerCase().includes('home'));
  const clinicType = doctor.consultation_types?.find(c => c.consultation_type_name.toLowerCase().includes('clinic') || c.consultation_type_name.toLowerCase().includes('hospital') || c.consultation_type_name.toLowerCase().includes('in-clinic'));

  return (
    <>
      <Header />

      <div className="test_bredcum_sec">
        <div className="container-fluid">
          <div className="test_bredcum">
            <Link to="/">Home</Link>
            <span>&gt;</span>
            <Link to="/doctor-consultation-services">Doctors</Link>
            <span>&gt;</span>
            <span className='name_p'>{doctor.doctor_name}</span>
          </div> 
        </div> 
      </div>

      <div className="doctor-detail-main">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
              <div className="top-doctor-detail">
                <div className="doctor-inner-details">
                  <div className="doctor-img">
                    <img 
                      src={doctor.doctor_profile_image || docimage} 
                      alt={doctor.doctor_name}
                      onError={(e) => { e.target.onerror = null; e.target.src = docimage; }}
                    />
                  </div>
                  <div className="doctor-content">
                    <div className="doc-name">
                      <h2>
                        {doctor.doctor_name} {String(doctor.doctor_is_verified) === "1" && <VerifiedIcon />}
                      </h2>
                      <span>
                        <ShareOutlinedIcon />
                      </span>
                    </div>
                    <label>{specialityText}</label>
                    <div className="doctor-info-detail">
                      <ul>
                        <li>
                          <LocalHospitalOutlinedIcon /> {doctor.doctor_experience || "0+"} Experience
                        </li>
                        <li>
                          <SchoolOutlinedIcon /> {doctor.doctor_qualification || "MBBS"}
                        </li>
                        <li>
                          <ClosedCaptionOutlinedIcon /> {languagesText}
                        </li>
                        <li>
                          <PlaceOutlinedIcon /> {doctor.city_name || "Jaipur"}, {doctor.state_name || "Rajasthan"}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="consultation-mode">
                  <button style={{ opacity: hasVideo ? 1 : 0.2 }}>
                    <VideocamIcon /> Online Consult
                  </button>
                  <button style={{ opacity: hasHome ? 1 : 0.2 }}>
                    <HomeIcon />
                    At Home Consult
                  </button>
                  <button style={{ opacity: hasClinic ? 1 : 0.2 }}>
                    <LocalHospitalIcon /> At Clinic Consult
                  </button>
                </div>
              </div>

              <div className="top-doctor-detail">
                <div className="doc-about">
                  <h3>About {doctor.doctor_name}</h3>
                  <p>{doctor.doctor_about_doctor || "No description provided."}</p>

                  <button
                    className="read-more-btn"
                    onClick={() => setShowMore(!showMore)}
                  >
                    {showMore ? "Read Less" : "Read More"}
                  </button>
                </div>

                {showMore && (
                  <>
                    <div className="whychoose-me">
                      <h3>Why Choose Me?</h3>

                      <div className="whychoose-points">
                        <div className="whychoose-points-inner">
                          <label>
                            <TaskAltOutlinedIcon />
                          </label>
                          <p>Guarantee</p>
                          <span>Trusted Doctor</span>
                        </div>

                        <div className="whychoose-points-inner">
                          <label>
                            <TaskAltOutlinedIcon />
                          </label>
                          <p>Experienced</p>
                          <span>{doctor.doctor_experience || "0+"}</span>
                        </div>

                        <div className="whychoose-points-inner">
                          <label>
                            <TaskAltOutlinedIcon />
                          </label>
                          <p>24/7 Support</p>
                          <span>Available</span>
                        </div>
                      </div>
                    </div>

                    <div className="what-include">
                      <h3>What's Included</h3>

                      <div className="what-include-points">
                        <ul>
                          <li>Comprehensive health assessment</li>
                          <li>Prescription and treatment plan</li>
                          <li>Follow-up consultation included</li>
                          <li>Digital health records</li>
                        </ul>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className="doctor-tabs-section">
                {/* Tabs */}
                <div className="doctor-tabs">
                  {tabs.map((tab) => (
                    <button
                      key={tab}
                      className={activeTab === tab ? "tab-btn active" : "tab-btn"}
                      onClick={() => setActiveTab(tab)}
                    >
                      {tab}
                    </button>
                  ))}
                </div>

                {/* Tab Content */}
                <div className="tab-content">
                  {activeTab === "Experience & Education" && (
                    <div className="content-box">
                      <h3>Experience</h3>
                      <div className="experience-item">
                        <h4>Practice History</h4>
                        <p>{doctor.doctor_experience || "0+"} of dedicated clinical practice and patient care.</p>
                      </div>

                      <h3 style={{ marginTop: '30px' }}>Education & Qualification</h3>
                      <div className="education-item">
                        <h4>Degrees / Professional Training</h4>
                        <p>{doctor.doctor_qualification || "MBBS"}</p>
                      </div>
                    </div>
                  )}

                  {activeTab === "Patient Reviews" && (
                    <div className="content-box">
                      <h3>Patient Reviews</h3>
                      {reviews.map((item) => (
                        <div className="review-card" key={item.id}>
                          <div className="review-top">
                            <div className="review-user">
                              <img src={item.image} alt="" />

                              <div>
                                <h4>{item.name}</h4>

                                <div className="stars">
                                  {[...Array(item.rating)].map((_, index) => (
                                    <StarOutlinedIcon key={index} />
                                  ))}
                                </div>
                              </div>
                            </div>

                            <span>{item.date}</span>
                          </div>

                          <p>{item.review}</p>
                        </div>
                      ))}
                    </div>
                  )}

                  {activeTab === "Availability" && (
                    <div className="content-box">
                      <h3>Availability</h3>
                      <table className="availability-table">
                        <tbody>
                          {doctor.availability && doctor.availability.length > 0 ? (
                            doctor.availability.map((slot, index) => (
                              <tr key={index}>
                                <td style={{ fontWeight: '600', width: '150px' }}>{slot.day_name}</td>
                                <td>{slot.slot_name}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="2">No availability schedule found.</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
              
              <div className="faq_in_packagedetail">
                <div className="faq_innner">
                  <h2 className="faq_heading_detail">Frequently Asked Questions (FAQs)</h2>

                  <div className="accordion" id="accordionExample">
                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                          What services does CaresAtHome provide?
                        </button>
                      </h2>
                      <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          We provide nursing care, physiotherapy, bedside attendants, ICU setup, doctor consultations, diagnostics, emergency services, and medical equipment support.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                          Can I book healthcare services at home?
                        </button>
                      </h2>
                      <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          We provide nursing care, physiotherapy, bedside attendants, ICU setup, doctor consultations, diagnostics, emergency services, and medical equipment support.
                        </div>
                      </div>
                    </div>

                    <div className="accordion-item">
                      <h2 className="accordion-header">
                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                          Are your caregivers and nurses verified?
                        </button>
                      </h2>
                      <div id="collapseThree" className="accordion-collapse collapse" data-bs-parent="#accordionExample">
                        <div className="accordion-body">
                          We provide nursing care, physiotherapy, bedside attendants, ICU setup, doctor consultations, diagnostics, emergency services, and medical equipment support.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-12 col-md-12 col-12">
              <div className="date_sedule_drdetail">
                <div className="tab_dr_detail">
                  <div className="tab_head_drdetail">
                    <ul className="nav mb-3" id="pills-tab" role="tablist">
                      <li className="nav-item" role="presentation">
                        <button className="nav-link" id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="false">Consult Online</button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button className="nav-link active" id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="true">At Home</button>
                      </li>
                      <li className="nav-item" role="presentation">
                        <button className="nav-link" id="pills-contact-tab" data-bs-toggle="pill" data-bs-target="#pills-contact" type="button" role="tab" aria-controls="pills-contact" aria-selected="false">At Clinic</button>
                      </li>
                    </ul> 
                  </div>
                  <div className="dr_detail_tab_content"> 
                    <div className="tab-content" id="pills-tabContent">
                      <div className="tab-pane fade" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                        <div className="name_price_drdetail">
                          <h4>Online Consult</h4>
                          <h5>₹ {videoType ? videoType.dct_consultation_fee : "500"}</h5>
                        </div>
                        {/* Calendar Dates Selection */}
                        <div className="inner_calender_sec">
                          <div className="date_cal_bookingform headins_time_sample-box">
                            <h4><CalendarMonthOutlinedIcon/> Select Date</h4>
                            <div className="select_date_bookingform">
                              <input type="radio" name="date" id="d1_online" defaultChecked hidden />
                              <label htmlFor="d1_online" className="date_box">
                                <span>Mon</span>
                                <h3>30</h3>
                              </label>

                              <input type="radio" name="date" id="d2_online" hidden />
                              <label htmlFor="d2_online" className="date_box">
                                <span>Tue</span>
                                <h3>31</h3>
                              </label>

                              <input type="radio" name="date" id="d3_online" hidden />
                              <label htmlFor="d3_online" className="date_box">
                                <span>Wed</span>
                                <h3>01</h3>
                              </label>
                            </div>
                          </div>
                          {/* Time Slots */}
                          <div className="morning_time_booking headins_time_sample-box">
                            <h4><WbTwilightOutlinedIcon/> Select Time</h4>
                            <div className="timeing_redio">
                              <input type="radio" id="time_online1" name="time_online" defaultChecked />
                              <label htmlFor="time_online1" className="time_box">
                                <span></span>
                                <p>10:00 to 11:00 AM</p>
                              </label>
                              <input type="radio" id="time_online2" name="time_online" />
                              <label htmlFor="time_online2" className="time_box">
                                <span></span>
                                <p>04:00 to 05:00 PM</p>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="submit_btn_cp">
                          <button type="submit" className="submit_btn_full">
                            <Link to="/icu-home-booking">Schedule Appointment</Link> 
                          </button>
                        </div>
                      </div>

                      <div className="tab-pane fade show active" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                        <div className="name_price_drdetail">
                          <h4>Home Consult</h4>
                          <h5>₹ {homeType ? homeType.dct_consultation_fee : "600"}</h5>
                        </div>
                        <div className="inner_calender_sec">
                          <div className="date_cal_bookingform headins_time_sample-box">
                            <h4><CalendarMonthOutlinedIcon/> Select Date</h4>
                            <div className="select_date_bookingform">
                              <input type="radio" name="date" id="d1_home" defaultChecked hidden />
                              <label htmlFor="d1_home" className="date_box">
                                <span>Mon</span>
                                <h3>30</h3>
                              </label>

                              <input type="radio" name="date" id="d2_home" hidden />
                              <label htmlFor="d2_home" className="date_box">
                                <span>Tue</span>
                                <h3>31</h3>
                              </label>
                            </div>
                          </div>
                          
                          <div className="morning_time_booking headins_time_sample-box">
                            <h4><WbTwilightOutlinedIcon/> Select Time</h4>
                            <div className="timeing_redio">
                              <input type="radio" id="time_home1" name="time_home" defaultChecked />
                              <label htmlFor="time_home1" className="time_box">
                                <span></span>
                                <p>11:00 to 12:00 PM</p>
                              </label>
                              <input type="radio" id="time_home2" name="time_home" />
                              <label htmlFor="time_home2" className="time_box">
                                <span></span>
                                <p>05:00 to 06:00 PM</p>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="submit_btn_cp">
                          <button type="submit" className="submit_btn_full">
                            <Link to="/icu-home-booking">Schedule Appointment</Link> 
                          </button>
                        </div>
                      </div>

                      <div className="tab-pane fade" id="pills-contact" role="tabpanel" aria-labelledby="pills-contact-tab">
                        <div className="name_price_drdetail">
                          <h4>Clinic Consult</h4>
                          <h5>₹ {clinicType ? clinicType.dct_consultation_fee : "800"}</h5>
                        </div>
                        <div className="inner_calender_sec">
                          <div className="date_cal_bookingform headins_time_sample-box">
                            <h4><CalendarMonthOutlinedIcon/> Select Date</h4>
                            <div className="select_date_bookingform">
                              <input type="radio" name="date" id="d1_clinic" defaultChecked hidden />
                              <label htmlFor="d1_clinic" className="date_box">
                                <span>Mon</span>
                                <h3>30</h3>
                              </label>
                            </div>
                          </div>
                          
                          <div className="morning_time_booking headins_time_sample-box">
                            <h4><WbTwilightOutlinedIcon/> Select Time</h4>
                            <div className="timeing_redio">
                              <input type="radio" id="time_clinic1" name="time_clinic" defaultChecked />
                              <label htmlFor="time_clinic1" className="time_box">
                                <span></span>
                                <p>09:00 to 10:00 AM</p>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="submit_btn_cp">
                          <button type="submit" className="submit_btn_full">
                            <Link to="/icu-home-booking">Schedule Appointment</Link> 
                          </button>
                        </div>
                      </div>
                    </div>
                  </div> 
                </div>

                <div className="need_help_drdetail">
                  <div className="icon_help_detail">
                    <CallIcon/>
                  </div>
                  <div className="text_number_drdetail">
                    <h4>Need Help? </h4>
                    <h5>+91-9521111603</h5>
                  </div>
                </div>
              </div> 
            </div>
          </div>
        </div>
      </div>
      <WhyTrust/>
      <Footer />
    </>
  );
}

export default DoctorDetail;
